import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react'
import { useDebouncedCallback } from 'use-debounce'

import { Search } from '@/icons'

export const SearchField = ({
  onSearch,
}: {
  onSearch: (search: string) => void
}) => {
  const deboundedSearch = useDebouncedCallback(
    (search: string) => onSearch(search),
    500,
  )

  return (
    <InputGroup w="auto">
      <InputLeftElement>
        {' '}
        <Search color="secondary.500" />
      </InputLeftElement>
      <Input
        placeholder="Hledat"
        onChange={(e) => deboundedSearch(e.target.value)}
      />
    </InputGroup>
  )
}
